/************
 Setup
 ************/

// both products' variants share one listbox, so keep them together for lookups
const products = [product, fasciaflow];
let activeProduct = product;
let quantity = 1;

// map of variant id to restock date, serialized in the section liquid
const restockDates = JSON.parse(document.querySelector("#productV35RestockJSON").textContent);

/************
 Swipers
 ************/

const productV35Swipers = {};
const productV35Thumbs = {};

// play video in the currently active slide (videos are muted + loop, so we never pause)
function playActiveSlideVideo(swiper) {
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector("video");
    if (!video) {
        return;
    }
    video.play();
}

document.querySelectorAll(".productV35Visual").forEach(function (visual) {
    const productId = visual.dataset.productId;

    productV35Thumbs[productId] = new Swiper(`#productV35ThumbnailsSwiper-${productId}`, {
        slidesPerView: "auto",
        spaceBetween: 5,
        breakpoints: {
            800: {
                slidesPerView: 6,
            }
        },
        loop: true,
        navigation: {
            nextEl: `#productV35ThumbnailsNext-${productId}`,
            prevEl: `#productV35ThumbnailsPrev-${productId}`,
        },
    });

    productV35Swipers[productId] = new Swiper(`#productV35Swiper-${productId}`, {
        navigation: {
            nextEl: `#productV35Swiper-${productId} .productV35SwiperNext`,
            prevEl: `#productV35Swiper-${productId} .productV35SwiperPrev`,
        },
        loop: true,
        thumbs: {
            swiper: productV35Thumbs[productId]
        },
        on: {
            init: function () {
                playActiveSlideVideo(this);
            },
            slideChange: function () {
                playActiveSlideVideo(this);
            }
        }
    });

    visual.querySelectorAll(".productV35GalleryItem").forEach(function (element) {
        element.addEventListener("click", function () {
            // gallery items map 1:1 to logical slides; slideToLoop keeps loop-mode clones from skewing the index
            productV35Swipers[productId].slideToLoop(getElIndex(this));
        });
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll(".productV35Video").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();

        // check if we're on mobile and if .videoPopupVideo.mobileOnly exists
        if (window.innerWidth < 800 && popup.querySelector(".videoPopupVideo.mobileOnly")) {
            popup.querySelector(".videoPopupVideo.mobileOnly").play();
            return;
        }
        popup.querySelector("video").play();
    });
});

/*****************
 Reviews
 ****************/

document.querySelector("#productV35Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
});

/*****************
 Variant Select
 ****************/

const variants = document.querySelector("#productV35Variants");
const variantsTrigger = document.querySelector("#productV35VariantsTrigger");
const variantsMenu = document.querySelector("#productV35VariantsMenu");
const variantsOptions = [...variantsMenu.querySelectorAll(".productV35VariantsMenuGroupListItem")];

// open the menu on the current selection so arrow keys carry on from there
function openVariants() {
    variants.classList.add("active");
    variantsTrigger.setAttribute("aria-expanded", "true");
    focusVariantsOption(variantsOptions.findIndex(option => option.getAttribute("aria-selected") === "true"));
}

function closeVariants(returnFocus) {
    variants.classList.remove("active");
    variantsTrigger.setAttribute("aria-expanded", "false");
    if (returnFocus) {
        variantsTrigger.focus();
    }
}

// clamp so the arrow keys stop at the ends rather than wrapping
function focusVariantsOption(index) {
    if (!variantsOptions.length) {
        return;
    }
    variantsOptions[Math.max(0, Math.min(index, variantsOptions.length - 1))].focus();
}

variantsTrigger.addEventListener("click", function () {
    if (variants.classList.contains("active")) {
        closeVariants(true);
        return;
    }
    openVariants();
});

variantsTrigger.addEventListener("keydown", function (e) {
    if (!["Enter", " ", "ArrowDown", "ArrowUp"].includes(e.key)) {
        return;
    }
    e.preventDefault();
    openVariants();
});

// one delegated handler for the whole menu — no per-option listeners
variantsMenu.addEventListener("click", function (e) {
    const option = e.target.closest(".productV35VariantsMenuGroupListItem");
    if (!option) {
        return;
    }
    selectVariant(option.dataset.variantId);
    closeVariants(true);
});

variantsMenu.addEventListener("keydown", function (e) {
    const index = variantsOptions.indexOf(document.activeElement);

    switch (e.key) {
        case "ArrowDown":
            e.preventDefault();
            focusVariantsOption(index + 1);
            break;
        case "ArrowUp":
            e.preventDefault();
            focusVariantsOption(index - 1);
            break;
        case "Home":
            e.preventDefault();
            focusVariantsOption(0);
            break;
        case "End":
            e.preventDefault();
            focusVariantsOption(variantsOptions.length - 1);
            break;
        case "Enter":
        case " ":
            e.preventDefault();
            if (index < 0) {
                break;
            }
            selectVariant(variantsOptions[index].dataset.variantId);
            closeVariants(true);
            break;
        case "Escape":
            e.preventDefault();
            closeVariants(true);
            break;
        case "Tab":
            closeVariants(false);
            break;
    }
});

// close whenever the click lands outside the select
document.addEventListener("click", function (e) {
    if (!variants.classList.contains("active") || variants.contains(e.target)) {
        return;
    }
    closeVariants(false);
});

/*****************
 Product Update
 ****************/

// point the page at a variant from either product and refresh everything that depends on it
function selectVariant(variantId) {
    const id = parseInt(variantId);

    activeProduct = products.find(item => item.variants.some(variant => variant.id === id));
    activeVariant = activeProduct.variants.find(variant => variant.id === id);

    updateVariants();
    updateVisual();
    updatePrice();
    updateATC();
    updateCopy();
    updateShipping();
    updateURL();
}

// keep ?variant=<id> in step with the selection so the page can be shared or reloaded as-is
function updateURL() {
    const url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// mirror the selection into the trigger and the option checkmarks
function updateVariants() {
    const selectedOption = variantsOptions.find(option => option.dataset.variantId === String(activeVariant.id));

    variantsTrigger.querySelector("#productV35VariantsTriggerImage").src = selectedOption.querySelector(".productV35VariantsMenuGroupListItemImage").src;
    variantsTrigger.querySelector("#productV35VariantsTriggerName").textContent = activeVariant.title;

    variantsOptions.forEach(function (option) {
        option.setAttribute("aria-selected", String(option === selectedOption));
    });
}

// swap the gallery to the active product, then slide to the variant's image
function updateVisual() {
    document.querySelectorAll(".productV35Visual").forEach(function (visual) {
        visual.classList.toggle("active", visual.dataset.productId === String(activeProduct.id));
    });

    // this swiper was likely built while its visual was display:none (so every slide measured 0px and loop math broke); re-measure now that it's visible or navigation stays dead until the next slideTo
    productV35Thumbs[activeProduct.id]?.update();
    productV35Swipers[activeProduct.id]?.update();

    // this specific variant should always show the first slide regardless of its featured image
    if (!activeVariant.featured_image || activeVariant.id === 48167894286586) {
        productV35Swipers[activeProduct.id].slideToLoop(0);
        return;
    }

    // find variant image — match by filename since product.media slide ids no longer line up with variant.featured_image.id
    const activeVisual = document.querySelector(`.productV35Visual[data-product-id="${activeProduct.id}"]`);
    const variantFilename = activeVariant.featured_image.src.split("/").pop().split("?")[0];

    // find the slide by filename, including loop clones (a clone carries the same logical index as its original)
    const variantSlide = [...activeVisual.querySelectorAll(".productV35SwiperSlide")].find(function (slide) {
        const image = slide.querySelector("img");
        return image && image.src.split("/").pop().split("?")[0] === variantFilename;
    });
    if (!variantSlide) {
        return;
    }

    // read Swiper's own logical index off the slide; loop mode rotates slides in the DOM so DOM position drifts after wrapping past the start
    productV35Swipers[activeProduct.id].slideToLoop(parseInt(variantSlide.dataset.swiperSlideIndex));
}

function updatePrice() {
    const compare = document.querySelector("#productV35PriceCompare");
    const actual = document.querySelector("#productV35PriceActual");
    const savings = document.querySelector("#productV35PriceSavings");

    actual.textContent = price(activeVariant.price, true);

    // only show the compare-at price and savings badge when the variant is actually discounted
    if (activeVariant.price >= activeVariant.compare_at_price) {
        compare.textContent = "";
        savings.classList.remove("active");
        return;
    }

    const savingsPct = Math.round((activeVariant.compare_at_price - activeVariant.price) / activeVariant.compare_at_price * 100);
    compare.textContent = price(activeVariant.compare_at_price, true);
    savings.textContent = `SAVE ${savingsPct}%`;
    savings.classList.add("active");
}

// an unavailable variant turns the button into the back-in-stock prompt
function updateATC() {
    const atc = document.querySelector("#productV35ATC");
    atc.classList.toggle("oos", !activeVariant.available);

    let text = atc.dataset.text;
    if (!activeVariant.available) {
        text = "Sold Out — Notify Me When Available";
    }
    atc.textContent = text;
}

// bullets and accordion copy follow whichever product the variant belongs to
function updateCopy() {
    let targetClass = "other";
    if (activeProduct.id === product.id) {
        targetClass = "default";
    }

    document.querySelectorAll(".productV35BulletsGroup, .productV35DropdownContentTxt").forEach(function (element) {
        element.classList.toggle("active", element.classList.contains(targetClass));
    });
}

/*****************
 Variant Init
 ****************/

// honour ?variant=<id> on load so a link can deep-link either product's colour
const urlVariantId = new URLSearchParams(window.location.search).get("variant");
if (urlVariantId && variantsOptions.some(option => option.dataset.variantId === urlVariantId)) {
    selectVariant(urlVariantId);
}

/**************
 Product ATC
 ***************/

// add to cart button
/*Code for adding Shipping Insurance*/
document.querySelector("#productV35ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: activeProduct.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", activeProduct.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    const lineItem = {
        quantity: quantity,
        id: activeVariant.id
    };

    // oversold variants with an upcoming restock carry the ship date through to the cart and checkout
    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        lineItem.properties = {
            Ships: formatShipsDate(restockDateObj)
        };
    }
    formData.items.push(lineItem);


    // check if we should go directly to checkout
    if (this.classList.contains("checkout")) {

        await clearCart();

        // add gift free gift
        formData.items.push(
            {
                quantity: 1,
                id: 47175294222586
            }
        )
        await addProduct(formData)

        window.location.href = "/checkout";

        // klaviyo tracking
        try {
            _learnq.push(["track", "Added to Cart", item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        // remove loading animation
        this.classList.remove("loading");

        return;
    }


    // add productV35
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(["track", "Added to Cart", item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }


    // open cart
    await openCart();


    // remove loading animation
    this.classList.remove("loading");

});

//space
// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV35ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV35AddonCheckboxInput").checked) {
            document.querySelector("#productV35AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV35ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

// ignore if noSticky class is present
if (!document.querySelector("#productV35ATC").classList.contains("noSticky")) {
    const stickyAtcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                document.querySelector("#productV35ATC").classList.remove("sticky");
                return;
            }
            document.querySelector("#productV35ATC").classList.add("sticky");
        });
    }, {
        rootMargin: "-100px 0px 0px 0px"
    })
    stickyAtcObserver.observe(document.querySelector("#productV35Content"));

}


// event listeners for dropdown items
document.querySelectorAll(`.productV35DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

/**************
 Shipping Time
 ***************/

// Consistent random number generation using the hash as a seed
function generateSeededRandom(key, min, max) {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash << 5) - hash + key.charCodeAt(i);
        hash |= 0;
    }

    const x = Math.sin(hash) * 10000;
    const seed = x - Math.floor(x);

    return Math.floor(seed * (max - min + 1) + min);
}

let ordersRemaining = localStorage.getItem("ordersRemaining");

// generate a fresh count when there isn't one cached for this product
if (!ordersRemaining || localStorage.getItem("productHandle") !== product.handle) {
    ordersRemaining = generateSeededRandom(product.handle, 10, 100);
    localStorage.setItem("ordersRemaining", ordersRemaining);
    localStorage.setItem("productHandle", product.handle);
}

document.querySelector("#productV35ShippingRemainingTxt").textContent = `${ordersRemaining} orders remaining`;

// the active variant's restock date, or null when it has none or it has already passed
function getRestockDate() {
    const restockDate = restockDates[activeVariant.id];
    if (!restockDate) {
        return null;
    }

    // build the restock date from its parts so "2026-07-01" is treated as a local date, not UTC (which shifts the day)
    const [year, month, day] = restockDate.split("-").map(Number);
    const restockDateObj = new Date(year, month - 1, day);
    if (new Date() >= restockDateObj) {
        return null;
    }

    return restockDateObj;
}

// format a date like "Oct 8th" for the Ships line item property
function formatShipsDate(date) {
    const day = date.getDate();

    // 11th, 12th and 13th break the st/nd/rd pattern
    let suffix = "th";
    if (day % 100 < 11 || day % 100 > 13) {
        suffix = {1: "st", 2: "nd", 3: "rd"}[day % 10] || "th";
    }

    return `${date.toLocaleDateString("en-US", {month: "short"})} ${day}${suffix}`;
}

// show the restock date as the ship date until it passes, otherwise ships tomorrow
function updateShipping() {
    const shippingDateTxt = document.querySelector("#productV35ShippingDateTxt");

    const restockDateObj = getRestockDate();
    if (restockDateObj) {
        const restockText = restockDateObj.toLocaleDateString("en-US", {month: "short", day: "numeric", year: "numeric"});
        shippingDateTxt.innerHTML = `Ships <strong>${restockText}</strong>`;
        return;
    }

    // no upcoming restock, so fall back to the default ships-tomorrow text
    const date = new Date();
    date.setDate(date.getDate() + 1);
    const dateText = date.toLocaleDateString("en-US", {month: "short", day: "numeric"});
    shippingDateTxt.innerHTML = `Ships <strong>Tomorrow, ${dateText}</strong>`;
}

// initial paint for the default variant (a ?variant= load already ran this through selectVariant)
updateShipping();
